import React from 'react';
import classNames from 'classnames';

import FormBody from './FormBody';
import FormHeader from './FormHeader';

import styles from './Form.module.scss';

interface ClassNamesProps {
  formHeader: string;
  formBody: string;
}

interface FormProps {
  title: JSX.Element | string | null;
  subtitle?: string | null;
  className?: string;
  classNames?: Partial<ClassNamesProps>;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  renderFooter?: () => JSX.Element | null;
}

const Form = ({
  classNames: customClassNames,
  className,
  title,
  subtitle,
  children,
  onSubmit,
  renderFooter,
}: React.PropsWithChildren<FormProps>) => (
  <>
    <form className={classNames(styles.form, className)} onSubmit={onSubmit}>
      <FormHeader title={title} className={customClassNames?.formHeader} />
      <FormBody title={subtitle} className={customClassNames?.formBody}>
        {children}
      </FormBody>
    </form>
    {renderFooter && renderFooter()}
    <div className={styles.have_a_question_section}>
      <p>Questions? Need help?</p>
      <p>Call us at (866) 367-3271</p>
    </div>
  </>
);

export default Form;
